import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.inviteError"],
  error => error
);
